import { useUser } from "@clerk/react";
import { useEffect } from "react";

import { GTM_CONTAINER_ID } from "~/constants/analytics";
import { isRecentAccount } from "~/feature/auth/utils/isRecentAccount";
import {
  hasSentSignUpEvent,
  markSignUpEventSent,
} from "~/feature/auth/utils/signUpEventMark";
import { DataLayerEvent, pushDataLayerEvent } from "~/scripts/tagManager";
import { isNewAccountSignIn } from "~/utils/isNewAccountSignIn";

export const useSignUpEvent = (): void => {
  const { user } = useUser();

  useEffect(() => {
    if (!GTM_CONTAINER_ID || !user || hasSentSignUpEvent(user.id)) {
      return;
    }

    if (
      !isNewAccountSignIn(user) ||
      !isRecentAccount(user.createdAt, Date.now())
    ) {
      return;
    }

    markSignUpEventSent(user.id);
    pushDataLayerEvent(DataLayerEvent.SignUp);
  }, [user]);
};
